import { Component, inject, signal } from '@angular/core';

import { FontIconComponent } from '@camelot/icons';
import { TranslatePipe } from '@camelot/translation';
import { CamTranslationService } from '@camelot/translation';
import {
  ListContainerComponent,
  ListElementComponent,
  ListTagComponent,
  ListTitleComponent,
  LoaderComponent,
} from '@camelot/ui';

import { CamTranslationUser } from '../../translation.service';

@Component({
  selector: 'cam-switch-language',
  templateUrl: './switch-language.component.html',
  styleUrls: ['./switch-language.component.scss'],
  imports: [
    TranslatePipe,
    FontIconComponent,
    ListTagComponent,
    ListElementComponent,
    ListTitleComponent,
    ListContainerComponent,
    LoaderComponent,
  ],
})
export class SwitchLanguageComponent {
  readonly translateService = inject(CamTranslationService);

  constructor() {
    CamTranslationUser.getInstance();
  }
  readonly languages = [
    { id: 'fr', name: 'Français' },
    { id: 'nl', name: 'Nederlands' },
    { id: 'en', name: 'English' },
    { id: 'es', name: 'Español' },
  ];

  public readonly activeLanguage = signal(this.translateService.getLanguage());
  public readonly changeLanguageAsked = signal(false);

  public changeLanguage(language: string) {
    if (this.activeLanguage() === language) {
      return;
    }

    this.changeLanguageAsked.set(true);
    this.translateService.use(language).subscribe({
      error: () => this.changeLanguageAsked.set(false),
      next: () => {
        this.activeLanguage.set(language);
        this.changeLanguageAsked.set(false);
      },
    });
  }
}
